const top = document.querySelector('.top')

if(top) {
	top.addEventListener('click', (e) => {
		e.preventDefault()

		scroll(0,0)
	})
}
